var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiImageMessageWebIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_511_1051",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.301758,
    width: 50.3416,
    height: 50.3416,
    rx: 25.1708,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_511_1051)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.497616,
    y: -0.195858,
    width: 51.3369,
    height: 51.3369,
    rx: 25.6684,
    fill: "#EEEEEE",
    stroke: "#EFEFEF",
    strokeWidth: 0.995232
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9757 18.5634C29.782 17.569 30.8293 16.5219 31.8235 12.7157C31.8878 12.4693 32.237 12.4693 32.3015 12.7157C33.2959 16.5219 34.343 17.5692 38.1492 18.5634C38.3956 18.6277 38.3956 18.977 38.1492 19.0414C34.343 20.0358 33.2957 21.0829 32.3015 24.8892C32.2372 25.1355 31.8879 25.1355 31.8235 24.8892C30.8291 21.0829 29.782 20.0356 25.9757 19.0414C25.7294 18.9771 25.7294 18.6279 25.9757 18.5634Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0787 14.0046C27.7924 13.8006 28.0316 13.5614 28.2354 12.8479C28.2612 12.7578 28.3888 12.7578 28.4146 12.8479C28.6187 13.5616 28.8578 13.8008 29.5713 14.0046C29.6614 14.0305 29.6614 14.158 29.5713 14.1838C28.8577 14.3879 28.6185 14.6271 28.4146 15.3406C28.3888 15.4307 28.2612 15.4307 28.2354 15.3406C28.0314 14.6269 27.7922 14.3877 27.0787 14.1838C26.9886 14.158 26.9886 14.0305 27.0787 14.0046Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7174 37.4097H17.2794C15.2706 37.4097 13.6362 35.7753 13.6362 33.7665V20.3285C13.6362 18.3196 15.2706 16.6853 17.2794 16.6853H23.9991V18.2385H17.2794C16.127 18.2385 15.1894 19.176 15.1894 20.3285V33.7665C15.1894 34.919 16.127 35.8565 17.2794 35.8565H30.7174C31.8699 35.8565 32.8074 34.919 32.8074 33.7665V26.7008H34.3606V33.7665C34.3606 35.7753 32.7263 37.4097 30.7174 37.4097Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4427 29.6726L19.7046 32.084H18.0912C18.3933 31.1854 20.646 23.8443 20.9844 22.8248H23.0876L26.1212 32.084H24.3973L23.6174 29.6726H20.4427ZM23.2788 28.3062C22.6323 26.256 22.1986 24.9123 21.999 24.0913H21.9815C21.7458 25.1424 21.3051 26.5804 20.7677 28.3062H23.2788Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.965 22.8249V32.084H27.3315V22.8249H28.965Z",
    fill: "#A4A4A4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiImageMessageWebIcon);
export default __webpack_public_path__ + "static/media/ai-image-message-web-icon.d51cda1d.svg";
export { ForwardRef as ReactComponent };